const tracePaymentTypes = {
    GET_TRACE_SUCCESS: "GET_TRACE_SUCCESS",
    GET_TRACE_ERROR: "GET_TRACE_ERROR",
    INITIATE_TRACE_SUCCESS: "GET_INITIATE_TRACE_SUCCESS",
    INITIATE_TRACE_ERROR: "GET_INITIATE_TRACE_ERROR",

};

export default tracePaymentTypes;
